import { motion } from "framer-motion";

export const MaskedLine = ({ children, delay = 0, className = "", as: Tag = "span" }) => (
    <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
            className={`block will-change-transform ${className}`}
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.span>
    </span>
);

export const FadeUp = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
        {children}
    </motion.div>
);

export const PageIntro = ({ kicker, title, intro, accent = "text-orange" }) => (
    <header className="relative px-5 pt-32 pb-14 sm:px-10 sm:pt-40 sm:pb-20 max-w-6xl mx-auto">
        <FadeUp>
            <p className={`font-hand text-2xl sm:text-3xl ${accent} -rotate-2 inline-block`}>{kicker}</p>
        </FadeUp>
        <FadeUp delay={0.08}>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-wide text-ink mt-2">
                {title}
            </h1>
        </FadeUp>
        {intro ? (
            <FadeUp delay={0.16}>
                <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-ink/80">{intro}</p>
            </FadeUp>
        ) : null}
    </header>
);
